"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const Button_1 = require("@Components/Buttons/Button");
const InnerForm_1 = __importDefault(require("@App/kit/fields/v2/InnerForm"));
const Form = (props) => {
    const { onSubmit, submitButtonLabel, icon, formFields, methods, disableSubmit } = props;
    const { handleSubmit } = methods;
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit) },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(InnerForm_1.default, { formFields: formFields }),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', icon: icon, submitType: 'submit', disabled: !!disableSubmit }, submitButtonLabel)))));
};
exports.default = Form;
